import { render } from "./FooterContent.vue?vue&type=template&id=1b65498f"
import script from "./FooterContent.vue?vue&type=script&lang=js"
export * from "./FooterContent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__